import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';

export const useIsLineItemFeatureEnabled = () => {
  return useFeature(FEATURES.TMP_TWO_WAY_MATCH_WITH_LINE_ITEMS);
};
